// extracted by mini-css-extract-plugin
export default {"sub-header":"style_sub-header__sydZ1","sub-header__action-buttons":"style_sub-header__action-buttons__BSdlP"};